import React, { useState, useEffect } from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,
  CardContent,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import _ from "lodash";
import { DataGrid } from "@material-ui/data-grid";
import { calculateVersionPlayableSize } from "../modules/playableSizeCalculator";

const useStyles = makeStyles(() => ({
  dialogPaper: {
    height: "40rem"
  }
}));

/**
 *
 * @param props
 * @returns {JSX.Element|null}
 */
export default function dialogPlayableSize(props) {
  const [isOpen, setOpen] = useState(false);
  const [totalSize, setTotalSize] = useState(0);
  const [componentSizes, setComponentSizes] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    props.setTotalSize(totalSize);
  }, [totalSize]);

  useEffect(() => {
    async function getSizes() {
      if (_.isNil(props.selectedVersion)) return;

      const { totalSize: totalSizeResult, componentSizes: calculatedSizes } = await calculateVersionPlayableSize(
        props.selectedVersion,
        props.selectedBase,
        props.assetEnabledByComponent,
        props.selectedLanguage
      );

      setComponentSizes(calculatedSizes);
      setTotalSize(totalSizeResult);
      props.setTotalSize(totalSizeResult);
    }
    getSizes();
  }, [props.selectedVersion, props.selectedLanguage]);

  function getColumns() {
    const columns = [
      {
        field: "id",
        headerName: "Id",
        hide: true
      },
      {
        field: "name",
        headerName: "Name",
        width: 250,
        renderCell: (props) => (
          <span className="size-name" style={{ width: "100%", height: "100%", outline: "none" }} title={props.value}>
            {props.value}
          </span>
        )
      }, //, width: "200px"
      {
        field: "type",
        headerName: "Type",
        width: 125,
        sortable: false,
        sortComparator: (v1, v2, param1, param2) => param1.data.type - param2.data.type
      }, //, width: "200px"
      {
        field: "size",
        headerName: "Size",
        width: 175,
        sortComparator: (v1, v2, param1, param2) => param1.data.size - param2.data.size,
        renderCell: (props) => (
          <span
            className="size-name"
            style={{ width: "100%", height: "100%", outline: "none" }}
            title={props.value}
          >{`${(props.value / 1024).toFixed(2)} kb`}</span>
        )
      }
    ];
    return columns;
  }

  return (
    <>
      <Card className={props.classes.card}>
        <CardContent>
          <Typography className={classes.title} variant={"h6"}>
            Playable Size
          </Typography>
          <div
            style={{
              marginTop: "0.5rem"
            }}
          >
            <Typography variant={"subtitle1"}>{`Total Estimated Size: ${parseFloat((totalSize / 1024 / 1024).toFixed(2))} MB`}</Typography>
          </div>
          <Button
            id={"playableSizeDetails"}
            color="secondary"
            variant="contained"
            label={"Details"}
            style={{
              margin: "1rem 5rem 0 0"
            }}
            onClick={() => {
              setOpen(true);
            }}
          >
            Details
          </Button>
        </CardContent>
      </Card>

      <Dialog
        open={isOpen}
        scroll="paper"
        fullWidth={true}
        maxWidth={"sm"}
        classes={{ paper: classes.dialogPaper }}
        onClose={() => {
          setOpen(false);
        }}
      >
        <DialogTitle
          disableTypography
          style={{
            textAlign: "center"
          }}
        >
          <Typography variant="h5">PLAYABLE SIZE</Typography>
        </DialogTitle>
        <DialogContent>
          <DataGrid
            id={"sizeDataGrid"}
            rows={componentSizes}
            columns={getColumns()}
            hideFooterRowCount={true}
            hideFooterSelectedRowCount={true}
            hideFooter={true}
            disableSelectionOnClick
          />
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <div>
            <Typography variant="h5" sx={{ whiteSpace: "pre-line" }}>
              {`Total Estimated Size: ${parseFloat((totalSize / 1024 / 1024).toFixed(2))} MB`}
            </Typography>
            <div style={{ margin: "1.5rem 4rem 0.5rem" }}>
              <Typography variant="subtitle2" sx={{ whiteSpace: "pre-line" }}>
                * Total max file size should be: 5 mb
              </Typography>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
